import React, { useEffect, useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import FullAboutPage from './pages/FullAboutPage';
import CataloguePage from './pages/CataloguePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import BestRehabEquipmentSupplier from './pages/blogs/BestRehabEquipmentSupplier';
import TopPhysiotherapyDealers from './pages/blogs/TopPhysiotherapyDealers';
import LeadingRehabCompany from './pages/blogs/LeadingRehabCompany';
import BestMobilityAids from './pages/blogs/BestMobilityAids';
import CompleteGuideRehab from './pages/blogs/CompleteGuideRehab';
import PhysioManufacturerChennai from './pages/blogs/PhysioManufacturerChennai';
import BestPhysioRehabManufacturer from './pages/blogs/BestPhysioRehabManufacturer';
import RehabManufacturerIndia from './pages/blogs/RehabManufacturerIndia';
import AdvancedHospitalChennai from './pages/blogs/AdvancedHospitalChennai';
import AdvancedTreatmentTables from './pages/blogs/AdvancedTreatmentTables';
import NotFoundPage from './pages/NotFoundPage';


import ScrollToTop from './components/ScrollToTop';
import SplashLoader from './components/SplashLoader';
import FloatingActions from './components/FloatingActions';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

const AppContent = () => {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <div key={location.pathname} className="page-transition-fade">
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<FullAboutPage />} />
          <Route path="/catalogue" element={<CataloguePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/product/:id" element={<ProductDetailsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/best-rehabilitation-equipment-supplier-tamil-nadu" element={<BestRehabEquipmentSupplier />} />
          <Route path="/blog/top-physiotherapy-equipment-dealers-tamil-nadu" element={<TopPhysiotherapyDealers />} />
          <Route path="/blog/leading-rehabilitation-equipment-company-tamil-nadu" element={<LeadingRehabCompany />} />
          <Route path="/blog/best-mobility-aids-rehab-products-tamil-nadu" element={<BestMobilityAids />} />
          <Route path="/blog/complete-guide-rehabilitation-equipment-tamil-nadu" element={<CompleteGuideRehab />} />
          <Route path="/blog/physiotherapy-rehabilitation-equipment-manufacturer-chennai" element={<PhysioManufacturerChennai />} />
          <Route path="/blog/best-physiotherapy-equipment-rehab-equipment-manufacturer" element={<BestPhysioRehabManufacturer />} />
          <Route path="/blog/rehabilitation-equipment-manufacturer-india" element={<RehabManufacturerIndia />} />
          <Route path="/blog/advanced-hospital-physiotherapy-equipment-manufacturer-chennai" element={<AdvancedHospitalChennai />} />
          <Route path="/blog/advanced-physiotherapy-treatment-tables-rehab-equipment" element={<AdvancedTreatmentTables />} />
          <Route path="/blog/:id" element={<BlogDetailPage />} />






          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </>
  );
};

function App() {
  // Always show splash on every full page load / hard refresh.
  // React in-app navigation never fully remounts App so splash won't
  // re-trigger on route changes — only on true browser loads/refreshes.
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashFinish = useCallback(() => {
    setShowSplash(false);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      direction: 'vertical',
      gestureDirection: 'vertical',
      smoothTouch: false,
      touchMultiplier: 2,
    });

    // Share lenis instance globally so ScrollToTop can access it
    window.lenis = lenis;

    // Attach ResizeObserver to recalculate Lenis scroll bounds
    // This fixes issues where the page height changes (e.g., images loading, mobile reflow) 
    // and Lenis gets stuck, preventing scrolling to the footer.
    const resizeObserver = new ResizeObserver(() => {
      lenis.resize();
    });
    // Use document.documentElement for more accurate full-page sizing
    resizeObserver.observe(document.documentElement);

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      resizeObserver.disconnect();
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <Router>
      <div className="App">
        {showSplash && <SplashLoader onFinish={handleSplashFinish} />}
        <AppContent />
        <FloatingActions />
      </div>
    </Router>
  );
}

export default App;
